<template>
    <button
        :class="{
            'cursor-not-allowed opacity-50': disabled,
            'cursor-wait': submitting
        }"
        :disabled="disabled"
        class="relative"
        type="submit">
        <span :class="{'invisible': submitting}">
            <slot></slot>
        </span>
        <span v-if="submitting" class="block absolute inset-0 flex justify-center items-center">
            <font-awesome-icon :spin="true" icon="spinner"/>
        </span>
    </button>
</template>


<script>

export default {

    props: {
        submitting: {
            required: true,
            type: Boolean
        },
        disabled: {
            default: false,
            type: Boolean
        },

    }
};

</script>
